import { gql } from '@apollo/client'

// Make changes responsibly because this fragment is used in searchByGuideTitle which may
// not return some values
const STUDY_GUIDE_FIELDS = gql`
  fragment StudyGuideFields on StudyGuideType {
    author {
      id
      fullName
      getAvatar {
        photo
      }
    }
    id
    coverImage
    featuredArticleDescription
    title
    description
    guideAsHtml
    withWhiteImageBG
    icon
    slug
    platform {
      id
      title
    }
    isUsedInSection
    tableOfContent {
      slug
      title
    }
    getCoverImage
    exploreSimilarGuides {
      id
      fullName
      coverImage
      title
      slug
    }
  }
`

const SUCCESS_STORY_SECTION_FIELDS = gql`
  ${STUDY_GUIDE_FIELDS}
  fragment StudyGuideSectionFields on StudyGuideSectionType {
    id
    title
    description
    platform {
      id
      title
    }
    studyGuide {
      ...StudyGuideFields
    }
    studyGuideIds
  }
`

export const FIND_ALL_STUDY_GUIDES_LIST = gql`
  query findAllStudyGuidesList($query: StudyGuideQueryInput!) {
    findAllStudyGuide(query: $query) {
      count
      items {
        id
        title
        updatedAt
        isUsedInSection
        author {
          id
          fullName
        }
        section {
          id
          title
        }
      }
    }
  }
`

export const FIND_ALL_STUDY_GUIDE_SECTIONS = gql`
  ${SUCCESS_STORY_SECTION_FIELDS}
  query findAllStudyGuideSection($query: StudyGuideSectionQueryInput!) {
    findAllStudyGuideSection(query: $query) {
      count
      items {
        ...StudyGuideSectionFields
      }
    }
  }
`

export const FIND_ONE_STUDY_GUIDE_SECTION = gql`
  ${SUCCESS_STORY_SECTION_FIELDS}
  query findOneStudyGuideSection($findOneStudyGuideSectionId: String!) {
    findOneStudyGuideSection(id: $findOneStudyGuideSectionId) {
      ...StudyGuideSectionFields
    }
  }
`

export const CREATE_STUDY_GUIDE_SECTION = gql`
  mutation createStudyGuideSection($createStudyGuideSectionInput: CreateStudyGuideSectionInput!) {
    createStudyGuideSection(createStudyGuideSectionInput: $createStudyGuideSectionInput) {
      id
      title
      description
      studyGuideIds
    }
  }
`

export const UPDATE_STUDY_GUIDE_SECTION = gql`
  mutation updateStudyGuideSection($updateStudyGuideSectionInputFieldName: UpdateStudyGuideSectionInput!) {
    updateStudyGuideSection(updateStudyGuideSectionInputFieldName: $updateStudyGuideSectionInputFieldName) {
      id
      title
      description
      studyGuideIds
    }
  }
`

export const FIND_ALL_STUDY_GUIDE = gql`
  ${STUDY_GUIDE_FIELDS}
  query findAllStudyGuide($query: StudyGuideQueryInput!) {
    findAllStudyGuide(query: $query) {
      count
      items {
        ...StudyGuideFields
      }
    }
  }
`

export const SEARCH_BY_GUIDE_TITLE = gql`
  ${STUDY_GUIDE_FIELDS}
  query searchByGuideTitle($searchString: String, $sectionId: String, $platformId: String) {
    searchByGuideTitle(searchString: $searchString, sectionId: $sectionId, platformId: $platformId) {
      count
      items {
        ...StudyGuideFields
      }
    }
  }
`

export const CREATE_STUDY_GUIDE = gql`
  mutation createStudyGuide($createStudyGuideInput: CreateStudyGuideInput!) {
    createStudyGuide(createStudyGuideInput: $createStudyGuideInput) {
      id
      title
      description
    }
  }
`

export const FIND_ONE_STUDY_GUIDE = gql`
  ${STUDY_GUIDE_FIELDS}
  query findOneStudyGuide($id: String!) {
    findOneStudyGuide(id: $id) {
      ...StudyGuideFields
    }
  }
`

export const UPDATE_STUDY_GUIDE = gql`
  ${STUDY_GUIDE_FIELDS}
  mutation updateStudyGuide($updateStudyGuideInputFieldName: UpdateStudyGuideInput!) {
    updateStudyGuide(updateStudyGuideInputFieldName: $updateStudyGuideInputFieldName) {
      ...StudyGuideFields
    }
  }
`

export const DELETE_STUDY_GUIDE = gql`
  mutation removeStudyGuide($removeStudyGuideId: String!) {
    removeStudyGuide(id: $removeStudyGuideId) {
      raw
      affected
    }
  }
`
